export default __webpack_public_path__ + "static/media/2122 spice rack top.3d3e00c3.png";